define('views/components/customer_note/customer_note',['require','backbone','text!templates/components/customer_note/customer_note.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/customer_note/customer_note.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'customer-note-item'
    });
});
